import { SidebarMenu } from './';
import clsx from 'clsx';
import { useDemo1Layout } from '../';

const SidebarContent = ({ height = 0 }) => {
  const { layout } = useDemo1Layout();
  const isCollapsed = layout.options.sidebar.collapse;
  return (
    <div
      className={clsx(
        'sidebar-content flex grow shrink-0 py-5 pe-2',
        'bg-[#50B553] group-hover:bg-white transition-colors duration-200'
      )}
    >
      <div
        className="scrollable-y-hover grow shrink-0 flex ps-2 pe-1 lg:pe-3"
        style={{ ...(height > 0 && { height: `${height}px` }) }}
      >
        <SidebarMenu isCollapsed={isCollapsed} />
      </div>
    </div>
  );
};

export { SidebarContent };
